export const routeChildren = (currentComponentName, $router, $route) => {
  let routes = $router.options.routes;
  let navRoute;
  let previousPath = '';

  for (const match of $route.matched) {
    if (!routes) {
      break;
    }
    navRoute = routes.find(r => {
      return `${previousPath}${r.path}` === match.path;
    });
    if (!navRoute || navRoute.component.name === currentComponentName) {
      break;
    }
    previousPath = `${previousPath}${navRoute.path}`;

    // add a "/" only if there isn't one already
    if (previousPath[previousPath.length - 1] !== '/') {
      previousPath = `${previousPath}/`;
    }
    routes = navRoute.children;
  }

  return navRoute?.children ?? [];
};
